import { __rest } from "tslib";
/** The parent <Tabs> component accecesses this component's propeties directly in order to present each Tab */
export const Tab = (_a) => {
    var { 
    /* eslint-disable @typescript-eslint/no-unused-vars */
    children, className, href, title, eventKey, tabContentId, tabContentRef, isHidden } = _a, props = __rest(_a, ["children", "className", "href", "title", "eventKey", "tabContentId", "tabContentRef", "isHidden"]);
    return null;
};
Tab.displayName = 'Tab';
//# sourceMappingURL=Tab.js.map